import {dateUtils, logging} from "@/utils/utils";

export default function issueCertificateCommonApis($apiInstance, $store) {
    return {
        getCustomerInfoByPhoneNumber: async (params) => {
            try {
                const response = await $apiInstance.get(`/customers/by/mobile/${params}`);
                return response;
            } catch (error) {
                console.log(error);
                throw error;
            } 
        },
        updateCustomerInfo: async (customerId, params) => {
            try {
                const response = await $apiInstance.put(`/customers/${customerId}`, params);
                return response;
            } catch (error) {
                console.log(error);
                throw error;
            } 
        },
        getHospitalMetadataByCompanyId: async (companyId) => {
            try {
                const response = await $apiInstance.get(`/companies/hospital/metadata/by/companyId/${companyId}`);
                return response;
            } catch (error) {
                console.log(error);
                throw error;
            } 
        },
    }
}
